module.exports = __webpack_public_path__ + "img/anchor6.648668d3.jpg";